import React, { Component } from 'react';
import { Modal, Spin, Button } from 'antd';
import { Store, Plus } from 'lucide-react';
import Inherit from '../../core/inherit';
import withNavigate from '../../core/withNavigate';
import StoresController from './stores.controller';
import { User } from '../../data';
import { canCreateClientsAndStores } from '../../core/access';

import { Layout, AnalyticsSkeleton, TableSkeleton, PageHeader } from '../common';
import { StoresMap, StoreTable, StoreTabs, StoreAnalytics } from './elements';
import CreateStoreDrawer from './elements/CreateStoreDrawer';
import { isFeatureEnabled } from '../../company/session';
import { FEATURES } from '../../company/features';

class ShelfStores extends Inherit(StoresController, Component) {
    state = {
        loading: true,
        stores: [],
        clients: [],
        open: false,
        rows: [],
        disabled: false,
        tab: 0,
        store: null,
        selectedRowKeys: [],
        bulkDeleting: false,
        visitedStoreIds: [],
        mapDateRange: null,
        mapRecencyLoading: false
    };

    renderTabContent() {
        const { stores, loading, rows, clients, open, disabled, tab, store, selectedRowKeys, bulkDeleting } = this.state;

        if (loading && tab === 0) {
            return (
                <div className="flex flex-col gap-4">
                    <AnalyticsSkeleton cards={5} />
                    <TableSkeleton rows={10} columns={7} />
                </div>
            );
        }

        switch (tab) {
            case 0:
                return (
                    <div className="flex flex-col gap-y-6">
                        <StoreAnalytics stores={stores} />
                        <StoreTable
                            stores={stores}
                            rows={rows}
                            loading={loading}
                            setRows={this.setRows.bind(this)}
                            showDrawer={this.showDrawer.bind(this)}
                            deactivateStore={this.deactivateStore.bind(this)}
                            selectedRowKeys={selectedRowKeys}
                            setSelectedRowKeys={(keys) => this.setState({ selectedRowKeys: keys })}
                            onBulkDeactivate={this.bulkDeactivateStores.bind(this)}
                        />
                        <Modal open={bulkDeleting} footer={null} closable={false} centered>
                            <div className="flex flex-col items-center gap-3 py-6 text-center">
                                <Spin size="large" />
                                <span className="mt-2 text-[15px] font-semibold text-surface-900">Eliminando pisos de venta...</span>
                                <span className="max-w-xs text-sm text-surface-500">Este proceso puede tardar un momento. Por favor ten paciencia.</span>
                            </div>
                        </Modal>
                        <CreateStoreDrawer
                            open={open}
                            store={store}
                            clients={clients}
                            disabled={disabled}
                            isEdit={store ? true : false}
                            setOpen={this.setOpen.bind(this)}
                            setStore={this.setStore.bind(this)}
                            createStore={this.createOrUpdateStore.bind(this)}
                            contextHolder={this.props.contextHolder}
                            createMultipleStores={this.createMultipleStores.bind(this)}
                        />
                    </div>
                );
            case 1:
                return (
                    <StoresMap
                        stores={stores}
                        clients={clients}
                        visitedStoreIds={this.state.visitedStoreIds}
                        mapDateRange={this.state.mapDateRange}
                        mapRecencyLoading={this.state.mapRecencyLoading}
                        onDateRangeChange={this.onMapDateRangeChange.bind(this)}
                        showRecency={isFeatureEnabled(FEATURES.STORE_CHECK_RECENCY)}
                    />
                );
            default:
                return null;
        }
    }

    render() {
        const { tab, loading } = this.state;
        // Creating stores lives in the loaded "Listado" tab (the drawer is rendered there).
        const canCreate = tab === 0 && !loading && canCreateClientsAndStores(User.getInstance()?.userType);

        return (
            <Layout current="stores">
                <PageHeader
                    icon={<Store />}
                    title="Pisos de Venta"
                    description="Gestiona los puntos de venta y su información"
                    actions={
                        canCreate && (
                            <Button type="primary" icon={<Plus />} onClick={() => this.showDrawer(true)}>
                                Crear PDV
                            </Button>
                        )
                    }>
                    <StoreTabs tab={tab} setTab={this.onTabChange.bind(this)} />
                </PageHeader>

                <div className="animate-in">{this.renderTabContent()}</div>
            </Layout>
        );
    }
}

export default withNavigate(ShelfStores);
